import { Color } from './color';
import { Appearance } from '../submodules/angular-ui-common/appearance';

export const appearance: Appearance = {
    publicArea: {
        header: {
            height: 100,
            bgColor: Color.light,
	        fontSize: '40px',
            fontColor: Color.main,
            logo: {
                front: {
                    show: true,
                    regular: {
                        src: './assets/images/header-logo.svg',
                        height: 56,
                        width: 118
                    },
                    compact: {
                        src: './assets/images/header-logo.svg',
                        height: 56,
                        width: 118
                    }
                },
                back: {
                    show: false
                }
            },
            menu: {
                show: true,
                mode: 'underlined',
                spacing: '6px',
                fontSize: '24px',
                fontColor: '#fff',
                selectedItemFontColor: '#fff',
                hoverItemFontColor: '#fff',
                bgColor: 'transparent',
                selectedItemBgColor: 'transparent',
                hoverItemBgColor: 'transparent',
                borderColor: 'transparent',
                selectedItemBorderColor: 'transparent',
                hoverItemBorderColor: 'transparent',
                underlineColor: 'transparent',
                selectedItemUnderlineColor: Color.auxiliary,
                hoverItemUnderlineColor: Color.auxiliary
            },
            profileSection: {
                show: true,
                hideIfNotAuthenticated: false
            },
            languageChooser: {
                show: false
            },
            contactUs: {
                show: true
            }
        },
        login: {
            bgColor: Color.auxiliary,
        }
    },
    privateArea: {
        header: {
            height: 60,
            bgColor: Color.light,
            fontColor: Color.main,
            logo: {
                front: {
                    show: true,
                    regular: {
                        src: './assets/images/header-logo.svg',
                        height: 56,
                        width: 118
                    },
                    compact: {
                        src: './assets/images/header-logo.svg',
                        height: 56,
                        width: 118
                    }
                },
                back: {
                    show: false
                }
            },
            menu: {
                show: false,
                mode: 'underlined',
                spacing: '2px',
                fontSize: '30px',
                fontColor: Color.auxiliary,
                selectedItemFontColor: Color.auxiliary,
                hoverItemFontColor: Color.auxiliary,
                bgColor: 'transparent',
                selectedItemBgColor: 'transparent',
                hoverItemBgColor: 'transparent',
                borderColor: 'transparent',
                selectedItemBorderColor: 'transparent',
                hoverItemBorderColor: 'transparent',
                underlineColor: 'transparent',
                selectedItemUnderlineColor: Color.auxiliary,
                hoverItemUnderlineColor: Color.auxiliary
            },
            languageChooser: {
                show: false
            },
            profileSection: {
                show: true
            },
            contactUs: {
                show: false
            },
            moreMenu: {
                show: false,
                languageChooser: {
                    show: false
                },
                about: {
                    show: true
                },
            }
        }
    },
    cards:{
        bgColor: 'white',
        border: 'none',
        borderRadius: '2px',
        shadow: true
    },
    dialogs:{
        bgColor: Color.auxiliary,
        fontColor: Color.light
    },
    cookiePolicyFooter: {
        bgColor: Color.main
    },
    chat: {
        userMessageBgColor: Color.main,
        interlocutorsMessageBgColor: Color.auxiliary
    }
}
